module.exports = __webpack_public_path__ + "static/media/SpartanHoplite.3c98c790.jpg";